import { gql } from 'graphql-request';

export const ADS_STACK_QUERY = gql`
  query ($assetId: String!) {
    adStacks(assetId: $assetId) {
      timeStamps
      videoReferenceId
    }
  }
`;
